<template>
	<div>
		<el-dialog title="修改讲师密码" width="600px" class="icon-dialog" :visible.sync="show" @open="open" :before-close="closeForm"
			append-to-body>
			<el-form :size="size" ref="form" :model="form" :rules="rules"
				:label-width="$store.getters.device !== 'mobile' ? '16%' : '90px'">
				<el-row>
					<el-col :span="24">
						<el-form-item label="新密码" prop="pass">
							<el-input v-model="form.pass" autoComplete="off" clearable
								placeholder="请输入新密码" :show-password="true" ></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :size="size" :loading="loading" type="primary" @click="submit">
					<span v-if="!loading">确 定</span>
					<span v-else>提 交 中...</span>
				</el-button>
				<el-button :size="size" @click="closeForm">取 消</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { getsetPass } from '../../api/userMG';
export default {
	name: 'Add',
	components: {
	},
	props: {
		show: {
			type: Boolean,
			default: false
		},
		size: {
			type: String,
			default: 'small'
		},
        lid: {
			type: Number,
		}
	},
	data() {
		return {
			headers: {
				token: localStorage.getItem('logintoken')
			},
			form: {
				lid: '',
				pass: ''
			},
			editorOption: {
			},
			classify: [],
			role_ids: [],
			loading: false,
			lists: [],
			pcidlist: [],
			rules: {
			},
			userinfo: {},
			type: [],
			updata: {
				file_name: 0
			}

		}
	},
	methods: {
		open() {
            this.form.lid = this.lid
            console.log(this.form,'=-====');
		},
		submit() {
			console.log(this.form);
			this.$refs['form'].validate(valid => {
				if (valid) {
					this.loading = true
					getsetPass(this.form).then(res => {
						console.log(res.code);
						if (res.code == 200) {
							this.$message({ message: '操作成功', type: 'success' })
							this.$emit('refesh_list')
							this.closeForm()
						} else {
							this.$message({ message: res.msg, type: 'error' })
							this.loading = false
						}
					}).catch(() => {
						// this.loading = false
					})
				}
			})
		},
		closeForm() {
			this.$emit('update:show', false)
			this.loading = false
			this.form = {
				lecturer_name: '',
			}
			if (this.$refs['form'] !== undefined) {
				this.$refs['form'].resetFields()
			}
		},
	}
}
</script>
<style scoped >
.editor {
	height: 200px;
}

.flexs {
	display: flex;
	justify-content: space-between;
	width: 600px;
	margin-bottom: 10px;
}


.videos {
	margin-top: 10px;
	width: 160px;
	height: 160px;
}

.avatar-uploader .el-upload {
	border-radius: 6px;
	cursor: pointer;
	position: relative;
	overflow: hidden;
}

.avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}

.avatar-uploader-icon {
	font-size: 28px;
	color: #8c939d;
	width: 100px;
	height: 100px;
	line-height: 100px;
	text-align: center;
	border: 1px solid #dadcdf;
	margin-top: 10px;
	border-radius: 10px;
}

.avatar {
	width: 100px;
	height: 100px;
	display: block;
	border: 1px solid #dadcdf;
}
</style>



// WEBPACK FOOTER //
// src/views/lecturer/updatepws.vue